import React, { createContext, useContext, useState, useEffect } from "react";
import store from "../store";

const CatalogMetaContext = createContext({ brands: [], families: [], loading: true });

export function CatalogMetaProvider({ children }) {
  const [brands, setBrands] = useState([]);
  const [families, setFamilies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    store.getCatalogMeta().then(({ brands: b, families: f }) => {
      setBrands(b || []);
      setFamilies(f || []);
      setLoading(false);
    });
  }, []);

  return (
    <CatalogMetaContext.Provider value={{ brands, families, loading }}>
      {children}
    </CatalogMetaContext.Provider>
  );
}

export function useCatalogMeta() {
  return useContext(CatalogMetaContext);
}
